var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_copy_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_copy_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M7.5 15c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 6 13.5v-10c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h8c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v10c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-8Zm0-1.5h8v-10h-8v10Zm-3 4.5c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 3 16.5V5.75c0-.213.071-.39.214-.534A.72.72 0 0 1 3.746 5c.21 0 .39.072.535.216a.72.72 0 0 1 .219.534V16.5h8.75c.213 0 .39.072.534.214a.72.72 0 0 1 .216.532c0 .21-.072.39-.216.535a.72.72 0 0 1-.534.219H4.5Z"
  }))));
};
export default SvgIconCopy;